import 'core-js';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from 'react-apollo';

import configureStore, { history } from './store';
import 'normalize.css';
import 'antd/dist/antd.css';
import './App.css';
import './i18next';

import * as serviceWorker from './serviceWorker';
import UserProfileForm from './component/auth/userProfile';
import {
  RegisterView,
  ForgotPasswordView,
  DashboardView,
  } from './view';
import { apolloConfig } from './config';
import ErrorMessageContainer from './container/ErrorMessageContainer';
// import ErrorBoundary from './view/ErrorBoundary';
// import IdleTimerContainer from './container/IdleTimerContainer';
const store = configureStore();
const client = new ApolloClient(apolloConfig);

ReactDOM.render(
  // <IdleTimerContainer>
    <ApolloProvider client={client}>
      <Provider store={store}>
        {/* <ErrorBoundary> */}
          <ConnectedRouter history={history} basename="readystream">
            <Switch>
             
              <Route path="/user-profile" exact component={UserProfileForm} />
              {/* <Route path="/login" exact component={LoginView} /> */}
              {/* <Route path="/country" exact component={CountrySelectView} /> */}
              <Route path="/register" exact component={RegisterView} />
              <Route path="/forgotPassword" exact component={ForgotPasswordView} />
              {/* <Route path="/resetPassword/:token" exact component={ResetPasswordView} /> */}
              <Route path="/error" exact component={ErrorMessageContainer} />
              <Route path="/readystream" exact component={DashboardView} />
              {/* <Route component={NotFoundView} /> */}
            </Switch>
          </ConnectedRouter>
        {/* </ErrorBoundary> */}
      </Provider>
    </ApolloProvider>
  // </IdleTimerContainer>
  , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
